export function toIsoDate(value: Date): string {
  const y = value.getFullYear()
  const m = String(value.getMonth() + 1).padStart(2, '0')
  const d = String(value.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function fromIsoDate(value: string): Date | null {
  const raw = String(value || '').trim()
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null
  const date = new Date(`${raw}T00:00:00`)
  return Number.isNaN(date.getTime()) ? null : date
}

export function todayIsoDate(): string {
  return toIsoDate(new Date())
}

export function monthStartIso(value: string): string {
  const date = fromIsoDate(value) || new Date()
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`
}

export function addDaysIso(value: string, days: number): string {
  const base = fromIsoDate(value) || new Date()
  base.setDate(base.getDate() + days)
  return toIsoDate(base)
}

export function getMonthDates(monthStart: string): string[] {
  const date = fromIsoDate(monthStart)
  if (!date) return []
  const year = date.getFullYear()
  const month = date.getMonth()
  const out: string[] = []
  const cursor = new Date(year, month, 1)
  while (cursor.getMonth() === month) {
    out.push(toIsoDate(cursor))
    cursor.setDate(cursor.getDate() + 1)
  }
  return out
}
